module.exports = __webpack_public_path__ + "static/media/happy_birds.64ac766e.mp3";